export class SendCodeModel {
    SelectedProvider: string;
    Email:string;
}